/**
 * @class QueryParams
 * @classdesc This class represents query params
 * that you can apply to url
 */

export class QueryParams {

    constructor(obj = {}) {
        for (let key in obj) {
            this[key] = obj[key];
        }
    }

    /**
     * @param params - object that represents query params
     * @returns {QueryParams} - query params instance based on params
     */
    static createParams(params) {
        return new this(params);
    }

    /**
     *
     * @param {string} query
     * @param {string} key
     * @param {string} value
     * @returns {string}
     */
    static appendParamToQuery(query, key, value) {
        let result = query;
        const encodedValue = encodeURIComponent(value);
        if (query.length) {
            result += `&${key}=${encodedValue}`;
        } else {
            result += `${key}=${encodedValue}`;
        }
        return result;
    }

    /**
     *
     * @param {string} url - url for query paramns applying
     * @returns {string}
     */
    applyToUrl(url) {
        let query = '';
        for (let key in this) {
            if (this.hasOwnProperty(key) && !_.isNull(this[key])) {
                query = QueryParams.appendParamToQuery(query, key, this[key]);
            }
        }
        return `${url}?${query}`;
    }
}


// WEBPACK FOOTER //
// ./src/common/utils/query-params.js